import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getBenefitFormList = ({ userId, groupId, planId } = {}) =>
  call(websocketFetch, 'get_benefit_form_list', {
    user_id: userId,
    group_id: groupId,
    plan_id: planId,
  });
